<bn-loading-overlay></bn-loading-overlay>
<div class="container mt-3 mx-auto">
  <div class="row">
    <div class="col">
      <h5>Habilitação Alternativa ({{novaHabilitacao ? 'cadastro' : 'edição ou suspensão'}})</h5>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="salvar()" *ngIf="podeSalvar()">Salvar
      </button>

      <button
        type="button"
        class="btn btn-danger"
        bnConfirm
        tituloConfirm="Confirmação"
        msgConfirm="Descartar {{novaHabilitacao ? 'novo cadastro' : 'edição'}} de habilitação?"
        *ngIf="novaHabilitacao || edicaoHabilitada"
        (onConfirm)="irParaPesquisa()">
        Cancelar
      </button>

      <button ngbTooltip="Realizar suspensão da habilitação alternativa" type="button" class="btn btn-warning" (click)="abrirSuspender()"
        *ngIf="!novaHabilitacao && !edicaoHabilitada && !desabilitaBotaoSuspender">Suspender
      </button>

      <button ngbTooltip="Retorna a tela anterior" type="button" class="btn btn-primary" (click)="irParaPesquisa()"
        *ngIf="!novaHabilitacao && !edicaoHabilitada">Voltar
      </button>
    </div>
  </div>
  <form [formGroup]="habilitacaoForm">
    <div class="row">
      <div *ngIf="novaHabilitacao" class="bn-form-group col-md-7">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <ng-select
          id="agenteFinanceiro"
          [items]="agentes"
          bindLabel="nome"
          [multiple]="false"
          [clearable]="true"
          [clearOnBackspace]="true"
          formControlName="agenteFinanceiroId"
          [searchable]="true"
          placeholder="Selecione"
          class="auto-grow"
          (change)="selecionar($event)">
          <ng-template ng-label-tmp let-item="item">
            {{ item.nome }}
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            container="body">
            {{ item.nome }} [{{ item.cnpj | bnCnpj }}]
          </ng-template>
        </ng-select>
      </div>
      <div *ngIf="!novaHabilitacao" class="bn-form-group col-md-7">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro</label>
        <input disabled id="agenteFinanceiro" class="form-control" formControlName="agenteFinanceiroId"/>
      </div>
      <div class="bn-form-group col-md-2" *ngIf="agenteFinanceiroSelecionado != null">
        <label class="form-label" for="cnpj-cotista">CNPJ</label>
        <input id="cnpj-costista" class="form-control" readonly [value]="agenteFinanceiroSelecionado?.cnpj | bnCnpj">
      </div>
    </div>
    <div class="row" *ngIf="agenteFinanceiroSelecionado != null">
      <div class="bn-form-group " [ngClass]="{'col-md-3': novaHabilitacao, 'col-md-4': !novaHabilitacao}">
        <label class="form-label" for="dataInicio">Data início vigência</label>
        <bn-datepicker name="dataInicio" idInput="dataInicio" formControlName="dataInicio" ngDefaultControl
          required="required" [minDate]="dataHoje">
        </bn-datepicker>
      </div>
      <div class="bn-form-group " [ngClass]="{'col-md-3': novaHabilitacao, 'col-md-4': !novaHabilitacao}">
        <label class="form-label" for="valorLimite">Valor Limite</label>
        <input id="valorLimite" class="form-control moeda" bnMask="MOEDA" formControlName="valorLimite"
          required="required">
      </div>
      <div class="bn-form-group " [ngClass]="{'col-md-3': novaHabilitacao, 'col-md-4': !novaHabilitacao}">
        <label class="form-label" for="dataMaximaValidade">Data máxima de validade</label>
        <bn-datepicker name="dataMaximaValidade" idInput="dataMaximaValidade" formControlName="dataMaximaValidade"
          ngDefaultControl required="required" [minDate]="dataHoje">
        </bn-datepicker>
      </div>
      <div *ngIf="novaHabilitacao" class="bn-form-group col-md-3"
        style="display: flex;justify-content: flex-end;align-items: flex-start;flex-direction: column; flex-basis: max-content;">
        <button type="button" class="btn btn-primary no-margin" (click)="incluir()"
          [disabled]="habilitacaoForm.invalid">Incluir habilitação
        </button>
      </div>
    </div>
  </form>
  <div class="table-responsive" *ngIf="habilitacoes.length != 0">
    <table class="table">
      <thead>
        <th>Data ínicio</th>
        <th>Valor Limite R$</th>
        <th>Data máxima de validade</th>
        <th *ngIf="!novaHabilitacao">Data suspensão</th>
        <th *ngIf="!novaHabilitacao">Justificativa suspensão</th>
        <th>Ações</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of habilitacoes; let indexItem = index"
          [ngClass]="(item?.situacao === 'SUSPENSO' ? 'row-disabled' : '')">
          <td>{{ item.dataInicio | date: 'dd/MM/yyyy' }}</td>
          <td>{{ item.valorLimite | bnMask: 'MOEDA' }}</td>
          <td>{{ item.dataMaximaValidade | date: 'dd/MM/yyyy'}}</td>
          <td *ngIf="!novaHabilitacao">{{ item.dataSuspensao | date: 'dd/MM/yyyy'}}</td>
          <td *ngIf="!novaHabilitacao">{{ item.justificativaSuspensao}}</td>
          <td>
            <a href="javascript:void(0)" *ngIf="item.id == null && (novaHabilitacao)" bnConfirm
              tituloConfirm="Confirmação" msgConfirm="Descartar novo cadastro de habilitação?"
              (onConfirm)="remover(indexItem)">
              <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top"
                ngbTooltip="Excluir Habilitação Alternativa"></i>
            </a>

            <i *ngIf="podeEditar(item, indexItem)" class="fa fa-pen text-primary ms-4" placement="left-top"
                    ngbTooltip="Editar a habilitação alternativa selecionada"
                    (click)="iniciarEdicao(item)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #msgTemplateSuspender>
  <b>Esta ação irá suspender todas as habilitações vigentes.</b>
  <br />
  <b>Deseja suspender a habilitação?</b>
  <br />
  <br />
  <label for="justificativaSuspensao">Justificativa da suspensão da habilitação</label>
  <textarea [maxLength]="500" id="justificativaSuspensao" class="bn-form-group col-md-12" [(ngModel)]="justificativaSuspensao"></textarea>

</ng-template>
<ng-template #botoesPersonalizadosSuspender>
  <button class="btn btn-md btn-success" (click)="suspender()">
    Sim
  </button>
  <button class="btn btn-md btn-danger" (click)="dismissModal()">
    Não
  </button>
</ng-template>
